import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAuth } from 'context/auth';

import { Page } from 'components/layouts';
import Alert from 'components/alert';

import HeaderSimple from 'components/header-simple';
import ErrorMessage from 'components/error-message';
import Field from 'components/field';
import Button from 'components/button';

import schema from './schema';

import './style.css';

const initialValues = { password: '', passwordConfirm: '' };

const ForgotPasswordValidate = () => {
  const { token } = useParams();
  const history = useHistory();
  const { resetPassword } = useAuth();
  const [error, setError] = useState();

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const { password } = values;
      await resetPassword({
        token,
        password,
      });
      history.push('/');
      toast.success('Password changed, try loging in again');
    } catch (e) {
      console.error(e);
      setSubmitting(false);
      setError(e);
    }
  };

  return (
    <Page
      className="page -forgot-password-validate"
      header={false}
      footer={false}
      theme="white"
    >
      <HeaderSimple />
      {error ? (
        <section className="forgot-password-validate-errors">
          <Alert type="error" message="Something went wrong">
            <p>Try clicking forgot my password again</p>
          </Alert>
        </section>
      ) : (
        <div className="forgot-password-validate-form-wrapper">
          <section className="forgot-password-validate-form">
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={schema}
            >
              <Form>
                <ErrorMessage name="password" />
                <Field
                  id="password"
                  name="password"
                  placeholder="Password"
                  type="password"
                />
                <ErrorMessage name="passwordConfirm" />
                <Field
                  id="password-confirm"
                  name="passwordConfirm"
                  placeholder="Confirm Password"
                  type="password"
                />
                <Button type="submit" hierarchy="tertiary">
                  Next
                </Button>
              </Form>
            </Formik>
          </section>
        </div>
      )}
    </Page>
  );
};

export default ForgotPasswordValidate;
